import { type QueryKey } from '@tanstack/react-query'

export const searchAccountsKey = (): QueryKey => ['search-accounts']
